import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { translations, LANGS } from "./translations";

const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("emlak_lang") : null;
    return LANGS.includes(saved) ? saved : "az";
  });

  useEffect(() => {
    localStorage.setItem("emlak_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => LANGS.includes(l) && setLangState(l), []);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) {
      if (node && typeof node === "object" && p in node) node = node[p];
      else return path;
    }
    return typeof node === "string" ? node : path;
  }, [lang]);

  // Every component in the tree calls useLang(), so this context sits above
  // most of the app — memoizing the value keeps consumers from re-rendering
  // whenever LanguageProvider re-renders for a reason unrelated to `lang`.
  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
